import { FormLabel, Island, Spacer, useDialog, useModal } from '@holta/ui';
import { useStore } from '../../../hooks/useStore';
import React from 'react';

import { useModalSupplierBaseProductContext } from '../context';

interface Props {
    children?: React.ReactNode;
}

export const SettingsTab: React.FC<Props> = () => {
    const { closeModal } = useModal();
    const { openGenericDialog } = useDialog();
    const [tab, setTab] = React.useState(0);

    const {
        supplierBaseProduct,
        isNew,
        handleDelete,
    } = useModalSupplierBaseProductContext();

    if (!supplierBaseProduct) {
        return null;
    }
    return (
        <>
            {!isNew && (
                <Island>
                    <Spacer xs={[1, 0]}>
                        <FormLabel>Delete Base Product</FormLabel>
                        <button className="danger" onClick={handleDelete}>
                            Delete
                        </button>
                    </Spacer>
                </Island>
            )}
        </>
    );
};
